import { VStack } from '@chakra-ui/react';
import React from 'react';
import { useTokens } from '../../../context/TokenProvider';
export const FormContainer = (props) => {
    const tokens = useTokens();
    return React.createElement(VStack, { align: "flex-start", gap: tokens.Spacing06, ...props });
};
